<template>
     <b-container>
        
        <b-row class="m-0">
            <span class="info-view-label"> Дистрибьютер: </span> 
            <span class="info-item"> 
                {{ tradePoint.AccountName }} 
            </span>
        </b-row>
        <hr class="my-4"/>

        <b-row class="m-0">
            <span class="info-view-label"> Дата последней накладной: </span> 
            <span class="info-item"> 
                {{ tradePoint.DateLastInvoice }} 
            </span>
        </b-row>
        <hr class="my-4"/>

        <b-row class="m-0">
            <span class="info-view-label"> DAX: </span>
            <span class="info-item"> 
                {{tradePoint.DaxId}} 
            </span>
        </b-row>
        <hr class="my-4"/>

        <b-row class="m-0">
            <span class="info-view-label"> Филиал: </span> 
            <span class="info-item"> 
                {{tradePoint.Branch}}
            </span>
        </b-row>
        <hr class="my-4"/>

        <b-row class="m-0">
            <span class="info-view-label"> Код регион: </span> 
            <span class="info-item"> 
                {{tradePoint.Region}}
            </span>
        </b-row>
        <hr class="my-4"/>

        <b-row class="m-0">
            <span class="info-view-label"> Дата последнего изменения: </span>
            <span class="info-item">  
                {{ getDateToDisplay(tradePoint.DateModified) }} 
            </span>
        </b-row>
        <hr class="my-4"/>

        <b-row class="m-0">
            <b-col>
                <span class="info-view-label v-center"> <b-row>Местоположение</b-row> </span>
                <span class="info-item"> 
                    <b-row class="m-0">
                        <span class="info-view-label"> долгота: </span> {{tradePoint.Location.Latitude}}
                    </b-row>
                    <b-row class="m-0">
                        <span class="info-view-label"> широта: </span> {{tradePoint.Location.Longitude}} 
                    </b-row>         
                </span>
            </b-col>
        </b-row>
        <hr class="my-4"/>

        <b-row class="m-0">
            <span class="info-view-label center"> Сеть: </span>
            <span class="info-item">  
                <yes-no-input v-model="tradePoint.MdRetailChainId" 
                              :is-disabled="true" />
            </span>
        </b-row>
        <hr class="my-4"/>

        <b-row class="m-0">
            <span class="info-view-label"> Адрес:</span>
            <span class="info-item">  
                {{tradePoint.Address}} 
            </span>
        </b-row>
        <hr class="my-4"/>

        <b-row class="m-0">
            <span class="info-view-label"> Категория торговой точки: </span>
            <span class="info-item">  
                {{type}} 
            </span>
        </b-row>
        <hr class="my-4"/>

        <b-row class="m-0">
            <span class="info-view-label"> PM: </span>
            <span class="info-item">  
                {{ tradePoint.IsPriceMonitoring ? "Да" : "Нет" }} 
            </span>
        </b-row>
        <hr class="my-4"/>

        <b-row class="m-0">
            <span class="info-view-label"> Тип торговой точки: </span>
            <span class="info-item">  
                {{subType}} 
            </span>
        </b-row>
        <hr class="my-4"/>

        <b-row class="m-0">
            <span class="info-view-label"> Средний объем продаж: </span>
            <span class="info-item">  
                {{tradePoint.AverageSales}} р/мес
            </span>
        </b-row>
        <hr class="my-4"/>

        <b-row class="m-0">
            <span class="info-view-label"> Средний размер заказа:  </span>
            <span class="info-item">  
                {{tradePoint.AverageSize}} р
            </span>
        </b-row>
        <hr class="my-4"/>

        <b-row class="m-0">
            <span class="info-view-label"> Среднее количество различного товара: </span>
            <span class="info-item">  
                {{tradePoint.AverageSku}} 
            </span>
        </b-row>
        <hr class="my-4"/>

        <b-row class="m-0">
            <span class="info-view-label"> Объем продаж из списка минимально необходимого ассортимента: </span>
            <span class="info-item">  
                {{tradePoint.MmlSales}} 
            </span>
        </b-row>
        <hr class="my-4"/>

        <b-row class="m-0">
            <span class="info-view-label"> Среднее количество различного товара: </span>
            <span class="info-item">  
                {{tradePoint.AverageSku}} 
            </span>
        </b-row>
        <hr class="my-4"/>

        <b-row class="m-0">
            <span class="info-view-label"> Сегмент: </span>
            <span class="info-item">  
                {{tradePoint.SegmentCode.Text}} 
            </span>
        </b-row>
        <hr class="my-4"/>

        <b-row class="m-0">
            <span class="info-view-label"> Формат: </span>
            <span class="info-item">  
                {{tradePoint.Format}} 
            </span>
        </b-row>
        <hr class="my-4"/>

        <b-row class="m-0">
            <span class="info-view-label"> Код розничной сети: </span>
            <span class="info-item">  
                {{tradePoint.RetailChainCode}} 
            </span>
        </b-row>
        <hr class="my-4"/>

        <b-row class="m-0">
            <span class="info-view-label"> День к которому привязаны сигналы магнита: </span>
            <span class="info-item">  
                {{getDateToDisplay(tradePoint.MagnitSignalDate)}}
            </span>
        </b-row>

    </b-container>
</template>

<script>
import YesNoInput from '@/components/shared/YesNoInput'

export default {
    props: {
        tradePoint: {
            type: Object,
            default: null
        }
    },
    computed: {
        type: function() {
            return this.tradePoint.Type ? this.tradePoint.Type.Text : null;
        },
        subType: function() {
            return this.tradePoint.SubType ? this.tradePoint.SubType.Text : null;
        }
    },
    methods: {
        getDateToDisplay: function(value) {
            let dateToDisplay = new Date(value);
            dateToDisplay = `${dateToDisplay.getDate()}.${dateToDisplay.getMonth()+1}.${dateToDisplay.getFullYear()} ${dateToDisplay.getHours()}:${dateToDisplay.getMinutes()}:${dateToDisplay.getSeconds()}`;
            return dateToDisplay;
        }
    },
    components: {
        YesNoInput
    }

}
</script>